import { Component, type ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '../ui/cn';

class TileErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidCatch(error: unknown) {
    console.error('Tahi: a tile failed to render', error);
  }
  override render() {
    return this.state.failed ? (
      <p className="text-sm text-muted">This tile couldn't load.</p>
    ) : (
      this.props.children
    );
  }
}

/** Tile chrome (design.md: radius 24, padding 16, Surface 2 with a Divider border, press scale 0.98). */
export function TileFrame({
  title,
  children,
  className,
  href,
}: {
  title: string;
  children: ReactNode;
  className?: string;
  /** On Today: the title opens the tile's module, so every tile is a way in. */
  href?: string;
}) {
  return (
    <section
      aria-label={title}
      className={cn(
        'flex h-full min-h-[120px] flex-col gap-1 rounded-[24px] border border-divider bg-surface-2 p-4',
        'motion-safe:transition-transform motion-safe:duration-100 motion-safe:active:scale-[0.98]',
        className,
      )}
    >
      <h2 className="text-xs font-medium uppercase tracking-[0.06em] text-muted">
        {href ? (
          <Link
            to={href}
            className="-my-3 inline-flex min-h-11 items-center hover:text-fg focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[var(--ring)]"
          >
            {title}
          </Link>
        ) : (
          title
        )}
      </h2>
      <TileErrorBoundary>{children}</TileErrorBoundary>
    </section>
  );
}
